<script lang="ts">
  import * as Sheet from '$lib/components/ui/sheet';
  import { cn } from '@/lib/utils';
  import Button from '@/lib/components/ui/button/button.svelte';
  import type { TodaysActivities } from '@/Common/constants';
  import TodayActivities from '../Today/TodayActivities.svelte';

  export let todaysActivities: TodaysActivities;
  export let open: boolean;
  export let currentDay: Date;

</script>

<Sheet.Root bind:open portal="#shadcn-ui-dialog-target">
  <Sheet.Content side="bottom" class={cn('flex flex-col gap-0 min-w-0 h-[95dvh] px-0')}>
    <div class='h-full w-full flex flex-col items-center bg-[#F9F9F9] border-t border-border gap-4 overflow-hidden mt-6 px-6'>
      <div class='flex-1 h-full w-full overflow-auto max-w-[1300px] py-4'>
        <TodayActivities {todaysActivities} {currentDay} isResyncing={false} />
      </div>
    </div>

    <Sheet.Footer class="border-t border-border pt-2">
      <Button variant="outline" type="submit" on:click={() => {
        open = false;
      }}>
        Close
      </Button>
    </Sheet.Footer>
  </Sheet.Content>
</Sheet.Root>
